import React, { useEffect, useState } from 'react'
import {
    Box,
    Typography,
    Grid,
    Link,
    Dialog,
    DialogContent,
    styled,
} from '@mui/material'
import { ReactComponent as CloseIconSvg } from 'icons/close-icon.svg'
import CustomButton from 'components/CustomButton'
import { useTranslation } from 'react-i18next'

const StyledDialog = styled(Dialog)({
    '-webkit-backdrop-filter': 'blur(4px)',
    backdropFilter: 'blur(4px)',
    backgroundColor: 'rgba(0, 0, 0, 0.15)',
})

const StyledDialogContentWrapper = styled(DialogContent)(({ theme }) => ({
    padding: '27px 46px 54px 50px',
    background: '#f7f8fa',
    maxWidth: 796,
    border: 'solid 1px #ebebed',
    borderRadius: '5px',
    boxShadow: '0 0 13px 0 rgba(0, 0, 0, 0.15)',
    [theme.breakpoints.down('sm')]: {
        padding: '27px 30px 54px 30px',
    },
}))

const StyledHeaderTypography = styled(Typography)({
    fontWeight: 'bold',
    marginLeft: 9,
})

const StyledCloseButton = styled(Box)({
    position: 'absolute',
    top: 16,
    right: 16,
})

const StyledModalContent = styled(Box)({
    padding: '40px 0px 42px 0px',
    minHeight: '325px',
})

const MessageTypography = styled(Typography)(({ variant }) => ({
    fontSize: '1.4rem',
    fontWeight: 'normal',
    padding: '0 1rem 2rem',
    color: variant === 'body1' ? '#028f09' : '#ff0000',
}))

export default function EditModal({
    open,
    onClose,
    header,
    body,
    loading,
    data,
    updateData,
    handleDiscard,
    actions,
    unsavedChanges,
    response,
}) {
    const [, setState] = useState({})

    useEffect(() => {
        //get data
        setState(data)
    }, [data])

    const { t } = useTranslation()
    return (
        <div>
            <StyledDialog
                aria-labelledby="simple-modal-title"
                maxWidth="md"
                open={open}
                onClose={onClose}
                scroll="body"
            >
                <StyledDialogContentWrapper>
                    <Box>
                        <StyledHeaderTypography
                            id="simple-modal-title"
                            variant="h5"
                        >
                            {t(`${header}`)}
                        </StyledHeaderTypography>
                        <StyledCloseButton>
                            <Link
                                component="button"
                                onClick={onClose}
                                aria-label="Close"
                                data-ai-explain="Close this dialog"
                            >
                                <CloseIconSvg></CloseIconSvg>
                            </Link>
                        </StyledCloseButton>
                    </Box>
                    <StyledModalContent>
                        <Box>{body}</Box>
                    </StyledModalContent>
                    <Box>
                        <MessageTypography
                            variant={
                                response && response.success ? 'body1' : 'body2'
                            }
                        >
                            {response && response.message}
                        </MessageTypography>
                    </Box>
                    <Box>
                        <Grid container spacing={2}>
                            <Grid item>
                                <CustomButton
                                    label={
                                        actions &&
                                        actions[1] &&
                                        actions[1].label
                                            ? actions[1].label
                                            : t('SaveChanges')
                                    }
                                    onClick={updateData}
                                    active={true}
                                    disabled={loading || !unsavedChanges}
                                    loading={loading}
                                    data-ai-explain="Save changes to this section"
                                />
                            </Grid>

                            <Grid item>
                                <CustomButton
                                    label={
                                        actions &&
                                        actions[1] &&
                                        actions[1].label
                                            ? actions[1].label
                                            : unsavedChanges
                                            ? t('DiscardChanges')
                                            : t('Close')
                                    }
                                    width={150}
                                    onClick={
                                        unsavedChanges ? handleDiscard : onClose
                                    }
                                    active={
                                        actions &&
                                        actions[0] &&
                                        actions[0].active
                                    }
                                    disabled={loading}
                                    data-ai-explain={
                                        unsavedChanges
                                            ? 'Discard unsaved changes'
                                            : 'Close this dialog'
                                    }
                                />
                            </Grid>
                        </Grid>
                    </Box>
                </StyledDialogContentWrapper>
            </StyledDialog>
        </div>
    )
}
